import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MatDialog, MatDialogConfig } from '@angular/material';
import { environment } from '../../environments/environment';

import { MatSnackBar } from "@angular/material";
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

import { ServicioService } from '../services/servicio.service';
import { Servicio } from '../models/servicio';
@Component({
  selector: 'app-servicio-img-extra-editor',
  templateUrl: './servicio-img-extra-editor.component.html',
  styleUrls: ['./servicio-img-extra-editor.component.css']
})
export class ServicioImgExtraEditorComponent implements OnInit {

  model: Servicio = new Servicio();
  models: Servicio[];

  servicio_id;

  imagen = "./assets/avatar.png";

  upload: boolean = false;
  selectedFile: File = null;

  Url = environment.imgUrl;
  loading: boolean = false;

  constructor(private modelService: ServicioService, public dialog: MatDialog, private dialogRef: MatDialogRef<ServicioImgExtraEditorComponent>, @Inject(MAT_DIALOG_DATA) data, private snackBar: MatSnackBar) {
    this.servicio_id = data.id;

    if (data.id != 0) {
      this.get(data.id);
    }
  }

  ngOnInit() {
  }

  get(id) {
    this.modelService.get(id).subscribe(
      val => {
        this.models = val.imagenes;
      },
      error => {
        console.log(<any>error);
      });

  }


  delete(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '300px';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        if (data == true) {
          this.modelService.deleteImg(id).subscribe(
            val => {
              this.get(this.servicio_id);
              this.snackBar.open('Registro Eliminado', '', {
                duration: 2000,
              });
            });
        }
      }
    );

  }

  onFileChange(event) {

    this.selectedFile = <File>event.target.files[0];
    this.upload = true;

    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.imagen = event.target.result;
    }
    reader.readAsDataURL(event.target.files[0]);
    // this.model.imagen = 'new';
    this.onUploadFile();
  }

  onUploadFile() {

    const data = new FormData();
    data.append('imagen', this.selectedFile, this.selectedFile.name);

    this.modelService.changeImageExtra(data, this.servicio_id).subscribe(
      val => {
        this.loading = false;
        this.snackBar.open('Registro Guardado', '', {
          duration: 2000,
        });

        this.imagen = "./assets/avatar.png";
        this.upload = false;
        this.selectedFile = null;
        this.get(this.servicio_id);
      });
  }

  close() {
    this.dialogRef.close();
  }
}
